import React, { useState, useEffect } from 'react'
import { useCbpdjListQuery } from '../../store/DianShangYeWuApi'
import { Table, Form, Space, Flex } from 'antd'
import classes from './costInvoice.module.css'
import CostListWithId from '../../document/cost/CostListWithId'
import CostInvoiceEdit from './CostInvoiceEdit'
import Icon from '../../cpn/Icon'
import ClientSelect from '../../system/client/ClientSelect'
function CostInvoiceListSubmitted(props) {
    const [form] = Form.useForm();
    const [list,setList] = useState([]);
    const [query, setQuery] = useState({
        "ddzc_kh_id": '',
    });
    const {data, isSuccess} = useCbpdjListQuery({
        cbpdj_qy_id:props.qy_id,
        cbpdj_uid:props.yh_id,
    },{refetchOnMountOrArgChange:1});
    useEffect(() => {
        if (isSuccess) {
            let arr = data.Result;
            if(query.ddzc_kh_id){
                arr = arr.filter((item) => item.cbpdj_kh_id === query.ddzc_kh_id);
            }
            setList(arr);
        }
    }, [data, isSuccess, query.ddzc_kh_id]);
    const columns = [
        {
            title: '付款客户',
            dataIndex: 'cbpdj_kh_name',
            key: 'cbpdj_kh_name',
            render: (text, record) => <CostInvoiceEdit 
                                            cbpdj_id={record.cbpdj_id} 
                                            yh_id={props.yh_id}
                                            yh_name={props.yh_name}
                                            qy_id={props.qy_id}
                                            qy_name={props.qy_name}
                                            cbpdj_kh_name={record.cbpdj_kh_name}
                                            cbpdj_state={record.cbpdj_state}
                                        />
            
        },
        {
            title: '成本票金额',
            dataIndex: 'cbpdj_amount',
            key: 'cbpdj_amount',
        },
        {
            title: '付款单号    ',
            dataIndex: 'cbpdj_ddzc_id',
            key: 'cbpdj_ddzc_id',
            render: (text, record) => <CostListWithId id={record.cbpdj_ddzc_id} qy_id={props.qy_id} yh_id={props.yh_id} yh_name={props.yh_name} />
        },
        {
            title: '提交记录',
            dataIndex: 'cbpdj_ctime',
            key: 'cbpdj_ctime',
            render: (text, record) => <span>{text} {record.cbpdj_uname}</span>
        },
        {
            title: '编号',
            dataIndex: 'cbpdj_id',
            key: 'cbpdj_id',
        },
    ]
    return (
        <>
            <Flex style={{ marginBottom: "10px" }} align='center' justify='space-between'>
                <Form
                    layout='inline'
                    name='form_cost_invoice_submitted'
                    form={form}
                    initialValues={{                        
                        ddzc_kh_id: query.ddzc_kh_id ? query.ddzc_kh_id : '',                        
                    }}
                    onFinish={(values) => {
                        console.log(values);
                        // Serialize dayjs objects to strings before storing
                        const serializedValues = {
                            ...values,
                            
                            ddzc_kh_id: values.ddzc_kh_id ? values.ddzc_kh_id : '',
                        };
                        
                            localStorage.setItem('jtg-caiwu_costInvoiceListSubmitted_ddzc_kh_id', JSON.stringify(serializedValues.ddzc_kh_id));
                        setQuery(prev => ({ 
                            ...prev, 
                            ddzc_kh_id: serializedValues.ddzc_kh_id, 
                        }));
                    }}
                >
                    <ClientSelect
                        onChange={(value) => {
                            setQuery(prev => ({ 
                                ...prev, 
                                ddzc_kh_id: value,                                     
                            }));
                            localStorage.setItem('jtg-caiwu_costInvoiceListSubmitted_ddzc_kh_id', JSON.stringify(value));
                        }}
                        qy_id={props.qy_id}
                        qy_name={props.qy_name}
                        yh_id={props.yh_id}
                        yh_name={props.yh_name}
                        style={{width:'250px'}}
                        placeholder='选择付款客户'
                        name='ddzc_kh_id'
                    />                                      
                    <Form.Item style={{marginLeft: 10}}>
                        <Space align='center' size='middle'>                           
                            <Icon type='reset'
                                onClick={() => {
                                    form.resetFields()
                                    localStorage.setItem('jtg-caiwu_costInvoiceListSubmitted_ddzc_kh_id', JSON.stringify(''))
                                    setQuery({
                                        "ddzc_kh_id": '',                                        
                                    })
                                    form.setFieldsValue({
                                        ddzc_kh_id: null,
                                    });
                                }}
                            />
                        </Space>
                    </Form.Item>
                </Form> 
            </Flex>
            <Table 
                className={classes.greenHeader}
                dataSource={list}
                columns={columns}
                pagination={false}
                size='small'
                bordered
                rowKey="cbpdj_id"
            />
        </>
    )
}

export default CostInvoiceListSubmitted